import React from 'react';

class CultureGeek extends React.Component {
    render() {
      return (
        <div className="article">
          <h1>The Hacker Manifesto</h1>
          <hr className="parchemin"/>
    
          <br/>
          <p className="tabulation">« Un autre s’est fait prendre aujourd’hui, c’est partout dans les journaux. "Scandale : Un adolescent arrêté pour crime informatique, "Arrestation d’un ’hacker’ après le piratage d’une banque"...
          Satanés gosses, tous les mêmes.</p>

          <p className="tabulation">Mais avez-vous, dans votre psychologie en trois pièces et votre profil technocratique de 1950, un jour pensé à regarder le monde derrière les yeux d’un hacker ? Ne vous êtes vous jamais demandé ce qui l’avait fait agir, quelles forces l’avaient modelé ? <br/> Je suis un hacker, entrez dans mon monde...<br/>
          Le mien est un monde qui commence avec l’école... Je suis plus astucieux que la plupart des autres enfants, les conneries qu’ils m’apprennent me lassent...</p>
      
          <p className="tabulation">Je suis au collège ou au lycée. J’ai écouté les professeurs expliquer pour la quinzième fois comment réduire une fraction.
          Je l’ai compris. "Non Mme Dubois, je ne peux pas montrer mon travail. Je l’ai fait dans ma tête"
          Satané gosses. Il l’a certainement copié. Tous les mêmes.</p>
      
          <p className="tabulation">J’ai fait une découverte aujourd’hui. J’ai trouvé un ordinateur.
          Attends une minute, c’est cool. Ca fait ce que je veux. Si ça fait une erreur, c’est parce que je me suis planté.
          Pas parce qu’il ne m’aime pas...
          Ni parce qu’il se sent menacé par moi...
          Ni parce qu’il pense que je suis petit filou...
          Ni parce qu’il n’aime pas enseigner et qu’il ne devrait pas être là...
          Satanés gosses. Tout ce qu’il fait c’est jouer. Tous les mêmes.</p>

          <p className="tabulation">Et alors c’est arrivé... une porte s’est ouverte sur le monde...
          Se précipitant a travers la ligne téléphonique comme de l’héroïne dans les veines d’un accro, une impulsion électronique est envoyée,
          On recherche un refuge à l’incompétence quotidienne... un serveur est trouvé.</p>

          <p className="tabulation">Vous vous répétez que nous sommes tous pareils...
          On a été nourri à la petite cuillère de bouffe pour bébé à l’école quand on avait faim d’un steak...
          Les fragments de viande que l’on nous a laissé étaient pré-machés et sans goût.
          On a été dominé par des sadiques ou ignoré par des apathiques.
          Les seuls qui avaient des choses à nous apprendre trouvèrent des élèves volontaires, mais ceux-ci sont comme des gouttes dans le désert.</p>

          <p className="tabulation">C’est notre monde maintenant... Le monde de l’électron et de l’interrupteur, la beauté du baud. Nous utilisons un service déjà existant, sans payer ce qui pourrait être bon marché si ce n’était pas la propriété de gloutons profiteurs, et vous nous appelez criminels.
          Nous explorons... et vous nous appelez criminels.
          Nous recherchons la connaissance... et vous nous appelez criminels.
          Nous existons sans couleur de peau, sans nationalité, sans dogme religieux... et vous nous appelez criminels.
          Vous construisez des bombes atomiques, vous financez les guerres,
          Vous ne punissez pas les patrons de la mafia aux riches avocats,
          Vous assassinez et trichez, vous manipulez et nous mentez en essayant de nous faire croire que c’est pour notre propre bien-être, et nous sommes encore des criminels.</p>

          <p className="tabulation">Oui, je suis un criminel. Mon crime est celui de la curiosité.
          Mon crime est celui de juger les gens par ce qu’ils pensent et disent, pas selon leur apparence.
          Mon crime est de vous surpasser, quelque chose que vous ne me pardonnerez jamais.</p>

          <p className="tabulation">Je suis un hacker, et ceci est mon manifeste.
          Vous pouvez arrêter cet individu, mais vous ne pouvez pas tous nous arrêter...
          Après tout, nous sommes tous les mêmes.»</p>

          <p style={{"font-style": "italic"}}> écrit le 8 janvier 1986, par le hacker Loyd Blankenship aka « The Mentor » après son arrestation</p>

          <hr className="parchemin"/>
        </div>
      );
    }
  }

  export default CultureGeek;  